module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"type":"Type","sandbox":"Sandbox","delete-carrier":"Delete Carrier","carrier-deleted":"Carrier deleted","failed-delete-carrier":"Failed to delete carrier"}}')
  delete Component.options._Ctor
}
